<section class="p-2 p-md-4">
  <div class="card">
    <div class="card-header bg-white">
      <h3>Dados de login</h3>
    </div>
    <div class="card-body row">
      <div class="col-12 col-lg-7 p-2">
        <label for="NomeCompleto">Nome Completo</label>
        <input [readonly]="desativarInputsEBotoes===true"  type="text" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.nome" name="NomeCompleto" id="NomeCompleto">
        <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-5 p-2">
        <label for="login">Login</label>
        <input [readonly]="desativarInputsEBotoes===true" type="text" autocomplete="false" class="form-control input-validate" [ngClass]="{'input-red': userAlreadyExist}" [formControl]="form.controls.login" name="login" id="login" (change)="existUser()">
        <app-msg-erro [control]="form.controls.login"></app-msg-erro>
        <span *ngIf="userAlreadyExist == true && !this.uuid" class="invalidMsg">Este Login já existe, insira outro</span>
      </div>
      <ng-container *ngIf="uuid==null">
        <div class="col-12 col-md-6 col-lg-3 p-2">
          <label for="senha">Senha</label>
          <input [readonly]="desativarInputsEBotoes===true" autocomplete="false" type="password" class="form-control input-validate" [formControl]="form.controls.senha" name="senha" id="senha">
          <app-msg-erro [control]="form.controls.senha"></app-msg-erro>
        </div>
        <div class="col-12 col-md-6 col-lg-3 p-2">
          <label for="confSenha">Confirmação de Senha</label>
          <input [readonly]="desativarInputsEBotoes===true" autocomplete="false" type="password" class="form-control input-validate" [formControl]="form.controls.senhaConf" name="confSenha" id="confSenha">
          <app-msg-erro [control]="form.controls.senhaConf"></app-msg-erro>
        </div>
      </ng-container>
      <div class="col-12 col-md-6 p-2" [ngClass]="{'col-lg-3': uuid==null}">
        <label for="email">E-mail</label>
        <input [readonly]="desativarInputsEBotoes===true" type="email" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.email" name="email" id="email">
        <app-msg-erro [control]="form.controls.email"></app-msg-erro>
      </div>
      <div class="col-12 col-md-6 p-2" [ngClass]="{'col-lg-3': uuid==null}">
        <label for="confEmail">Confirmação de E-mail</label>
        <input [readonly]="desativarInputsEBotoes===true" type="email" autocomplete="false" class="form-control input-validate" [formControl]="form.controls.emailConf" name="confEmail" id="confEmail">
        <app-msg-erro [control]="form.controls.emailConf"></app-msg-erro>
      </div>

      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="usuario.administrador" label="Administrador?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="usuario.acessoTodasConsultas" label="Visualizar histórico de terceiros?"></app-checkbox>
      </div>
      <div class="col-12 col-lg-4 p-2">
        <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="usuario.exibirConsultaAvulsa" label="Exibir consulta avulsa?"></app-checkbox>
      </div>
    </div>

    <div class="card-header mt-4 bg-white">
      <h3>Autorizações</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let r of usuario.listaPermissao" class="col-12 col-lg-4 p-2">
          <app-checkbox [(checked)]="r.checked" [label]="r.nome" [disabled]="disabledPermissoes || desativarInputsEBotoes"></app-checkbox>
        </div>
        <div class="w-100 p-3 d-flex justify-content-end">
          <app-checkbox [(disabled)]="desativarInputsEBotoes" class="md" (checkedChange)="checkedChangeAutorizacao($event)" [checked]="checkedPermissoes" label="Marcar todos"></app-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-4">
    <div class="card-header bg-white">
      <h3>Consultas</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let c of usuario.listaConsultas" class="col-12 col-lg-4 p-2">
          <app-checkbox  [(checked)]="c.checked" [label]="c.nome" [disabled]="disabledConsultas || desativarInputsEBotoes"></app-checkbox>
        </div>
        <div class="w-100 p-3 d-flex justify-content-end">
          <app-checkbox [(disabled)]="desativarInputsEBotoes" class="md" (checkedChange)="checkedChangeConsultas($event)" [checked]="checkedConsultas" label="Marcar todos"></app-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-4">
    <div class="card-header bg-white">
      <h3>Consultas Combinadas</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let r of usuario.listaConsultasCombinadas" class="col-12 col-lg-4 p-2">
          <app-checkbox [(disabled)]="desativarInputsEBotoes" [(checked)]="r.checked" [label]="r.nome"></app-checkbox>
        </div>
      </div>
    </div>
    <div *ngIf="desativarInputsEBotoes===false" class="card-footer bg-white d-flex justify-content-end">
      <button (click)="sendForm()" class="btn btn-lg px-5 btn-success" [disabled]="userAlreadyExist == true">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>
